import { IProduct } from "@faire/web-api--source/indigofair/data/IProduct";
import { IProductOption } from "@faire/web-api--source/indigofair/data/IProductOption";

/**
 * According to has_prepacks_available
 * this only exists on certain endpoints.
 * Ensure that the product passed in actually has
 * the field if this would be used in other endpoints in the
 * future.
 */
export const isPrePackProduct = (
  product?: Pick<IProduct, "has_pre_packs_available">
) => product?.has_pre_packs_available;

export const isPrePackProductOption = (
  productOption: Pick<IProductOption, "type">
) => productOption.type === IProductOption.Type.PRE_PACK;
